import * as CSS from 'csstype'

export const fontWeights = {
  300: 300,
  400: 400,
  500: 500,
  600: 600,
  700: 700,
  800: 800,
}

export const fontSizes = {
  10: '0.625rem',
  12: '.75rem',
  14: '.875rem',
  16: '1rem',
  18: '1.125rem',
  20: '1.25rem',
  24: '1.5rem',
  32: '2rem',
  40: '2.5rem',
}

/** @deprecated */
export const fontTitleSizes = [
  '1rem', // 16px
  '1.25rem', // 20px
  '1.5rem', // 24px
  '2rem', // 32px
  '2.5rem', // 40px
]

export const lineHeights = {
  none: '100%',
  4: 'calc(100% + 0.25rem)',
  8: 'calc(100% + 0.5rem)',
}

/** @deprecated */
export const titleLineHeights = ['1.5rem', '1.75rem', '2rem', '2.5rem', '3rem']

export const family = {
  primary: ['Inter', 'system-ui', '-apple-system', 'BlinkMacSystemFont'].join(','),
  monospace: ['Consolas', 'SFMono-Regular', 'Menlo', 'monospace'].join(','),
}

export type FontProps = {
  fontFamily?: 'primary' | 'monospace'
  fontWeight?: keyof typeof fontWeights
}

export type TextDecorationProps = {
  textDecoration?: CSS.Property.TextDecoration
}

export const settings = {
  fontSizes,
  fontWeights,
  fontTitleSizes,
  fonts: family,
  lineHeights,
  titleLineHeights,
}

export type FontThemes = typeof settings
